/**
 * Remove HTML tags from a string without regex backtracking.
 * @param {string} html
 * @returns {string}
 */
export function stripHtmlTags(html) {
  if (!html) return "";

  let result = "";
  let i = 0;

  while (i < html.length) {
    const tagStart = html.indexOf("<", i);
    if (tagStart === -1) {
      result += html.slice(i);
      break;
    }

    result += html.slice(i, tagStart);
    const tagEnd = html.indexOf(">", tagStart);
    if (tagEnd === -1) {
      result += html.slice(tagStart);
      break;
    }

    i = tagEnd + 1;
  }

  return result;
}
